'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('react');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var exclamationMark = require('./exclamation-mark-02f43bf2.js');
var index_es = require('./index.es-1f72f6f2.js');

var RadioButtonFormContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"])));
var RadioButtonsFormTitle = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font: normal 14px/22px ", ";\n  display: flex;\n  color: ", ";\n  margin-bottom: 18px;\n"], ["\n  font: normal 14px/22px ", ";\n  display: flex;\n  color: ", ";\n  margin-bottom: 18px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var RequiredIconBlock = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  font-size: 6px;\n"], ["\n  color: ", ";\n  font-size: 6px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.$alertRed;
});
var RequiredIcon = styled__default(index_es.FontAwesomeIcon)(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  height: auto;\n  position: relative;\n  top: -3px;\n  margin: 3px;\n  color: ", ";\n"], ["\n  height: auto;\n  position: relative;\n  top: -3px;\n  margin: 3px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.$alertRed;
});
var ErrorLabel = styled__default.div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  font: italic 12px/17px ", ";\n  color: ", ";\n"], ["\n  font: italic 12px/17px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$adminPink;
});
var ErrorWrapper = styled__default.div(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 5px;\n  margin-left: 25px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 5px;\n  margin-left: 25px;\n"])));
var StyledErrorIcon = styled__default(exclamationMark.ExclamationMark)(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  margin: 0 5px;\n  flex-shrink: 0;\n"], ["\n  margin: 0 5px;\n  flex-shrink: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

exports.ErrorLabel = ErrorLabel;
exports.ErrorWrapper = ErrorWrapper;
exports.RadioButtonFormContainer = RadioButtonFormContainer;
exports.RadioButtonsFormTitle = RadioButtonsFormTitle;
exports.RequiredIcon = RequiredIcon;
exports.RequiredIconBlock = RequiredIconBlock;
exports.StyledErrorIcon = StyledErrorIcon;
